import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { gr } from "../tokens";

// A question and the member's answer, read only (a submitted form, a preview).
// The answer can be text or any node (chips, images); empty → a grey "Not answered".
// Rows follow each other with a hairline between them.
export default function GrAnswerRow({ number, question, answer, emptyText = "Not answered", sx }) {
  const empty =
    answer == null ||
    answer === false ||
    (typeof answer === "string" && answer.trim() === "") ||
    (Array.isArray(answer) && answer.length === 0);
  return (
    <Box
      sx={{
        py: gr.space[4],
        "&:first-of-type": { pt: 0 },
        "&:last-of-type": { pb: 0 },
        "& + &": { borderTop: `1px solid ${gr.color.line2}` },
        ...sx,
      }}
    >
      <Box
        component="p"
        sx={{
          display: "flex",
          gap: gr.space[2],
          m: 0,
          fontFamily: gr.font.family,
          fontSize: gr.font.size.sm,
          fontWeight: gr.font.weight.medium,
          color: gr.color.ink2,
        }}
      >
        {number != null ? (
          <Box component="span" sx={{ color: gr.color.muted, flex: "none" }}>
            {number}.
          </Box>
        ) : null}
        <Box component="span" sx={{ minWidth: 0, overflowWrap: "anywhere" }}>
          {question}
        </Box>
      </Box>
      <Box
        sx={{
          mt: gr.space[2],
          fontFamily: gr.font.family,
          fontSize: gr.font.size.md,
          color: empty ? gr.color.muted : gr.color.ink,
          whiteSpace: typeof answer === "string" ? "pre-wrap" : undefined,
          overflowWrap: "anywhere",
        }}
      >
        {empty ? emptyText : answer}
      </Box>
    </Box>
  );
}

GrAnswerRow.propTypes = {
  number: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  question: PropTypes.node.isRequired,
  answer: PropTypes.oneOfType([PropTypes.node, PropTypes.array]),
  emptyText: PropTypes.node,
  sx: PropTypes.object,
};
